import { AppConfig } from '@/app-config';

export class PathUtils {
	public static GetUserBucketPath(
		userId: string,
		userName: string,
		channelId: string,
		bucketName: string): string {
		// {チャンネル名}/生徒/{バケット名}
		const channelFolderName: string = AppConfig.CHANNEL_ID_TO_CHNNAEL_FOLDERNAME[channelId];
		const userFolderName: string = `${userName}_${userId}`;
		const path: string = `${channelFolderName}/生徒/${userFolderName}/${bucketName}`;
		return path;
	}

	public static GetUserSubmitReportPath(
		userId: string,
		userName: string,
		channelId: string,
		bucketName: string): string {
		// {チャンネル名}/生徒/{バケット名}/{タスク名}
		let path: string = this.GetUserBucketPath(userId, userName, channelId, bucketName);
		path += `/${AppConfig.USER_TASK_FOLDERNAME_SUBMITREPORT}`;
		return path;
	}

	public static GetUserCheckScorePath(
		userId: string,
		userName: string,
		channelId: string,
		bucketName: string): string {
		// {チャンネル名}/生徒/{バケット名}/{タスク名}
		let path: string = this.GetUserBucketPath(userId, userName, channelId, bucketName);
		path += `/${AppConfig.USER_TASK_FOLDERNAME_CHECKSCORE}`;
		return path;
	}

	public static GetAdminBucketPath(channelId: string, bucketName: string): string {
		// {チャンネル名}/運営/{バケット名}
		const channelFolderName: string = AppConfig.CHANNEL_ID_TO_CHNNAEL_FOLDERNAME[channelId];
		const path: string = `${channelFolderName}/${AppConfig.ADMIN_ROOT_FOLDER_NAME}/${bucketName}`;
		return path;
	}
}
